export interface IOption {
  value: string | number | null;
  label: string;
  handleValue?: any;
  handleLabel?: any;
  small?: boolean;
}

export default function FormOption(props: IOption) {
  return (
    <div
      onClick={() => {
        props.handleValue(props.value);
        props.handleLabel(props.label);
      }}
      className={`text-left box-border p-3 text-brij-DarkGrey hover:text-brij-Blue hover:bg-gray-100 w-full ${
        props.small && "text-xsmall font-medium"
      }`}
    >
      {props.label}
    </div>
  );
}
